






import Vue from 'vue'

import HistoricalTable from '@/panels/table-datalog/table-datalog.component.vue'

export default Vue.extend({
  name: 'ComponentName',
  components: { HistoricalTable },
  data() {
    return {
      model: {},
    }
  },
  methods: {},
})
